import { takeLatest } from 'redux-saga/effects';

import { LOGIN, EDIT_PROFILE, LOGOUT, GET_LOGGED_USER } from './loginAction';
import { loginSaga, editProfileSaga, logoutSaga, getLoggedUserSaga } from './loginSaga';

export function* loginWatchers() {
  yield takeLatest(LOGIN, loginSaga);
  yield takeLatest(EDIT_PROFILE, editProfileSaga);
  yield takeLatest(LOGOUT, logoutSaga);
  yield takeLatest(GET_LOGGED_USER, getLoggedUserSaga);
}
